<template>
    <div id="m-inbox" style="height: 100%">
        <v-overlay v-if="loading">
            <v-progress-circular indeterminate color="primary"/>
        </v-overlay>
        <v-alert type="error" width="20%" v-else-if="message" style="margin-top: 50px;margin-left: 50%;left: -10%;">
            {{ message }}
        </v-alert>
        <v-card v-else elevation="0">
            <v-card-actions class="ma-0 pa-0 mx-3">
                <v-tabs v-model="tab" class="no-transition">
                    <v-tab key="tab-c-l" :disabled="!ifCanViewDrafts()" @click="updateActiveTab(1)">Draft
                        <v-icon size="20" style="margin-left: 8px">mdi-alert-rhombus-outline</v-icon>
                    </v-tab>
                    <v-tab key="tab-c-pre-release" :disabled="!ifCanViewActive()" @click="updateActiveTab(2)">Active
                        <v-icon size="20" style="margin-left: 8px">mdi-flower-outline</v-icon>
                    </v-tab>
                </v-tabs>
            </v-card-actions>
            <v-card-actions class="ma-0 pa-0 mx-3 mt-2">
                <v-card width="100%" class="ma-0 pa-0" elevation="0">
                    <v-card-actions class="ma-0 pa-0">
                        <v-card width="100%" class="ma-0 pa-0" elevation="0">
                            <v-tabs-items class="mt-0" v-model="tab">
                                <v-tab-item
                                    transition="fade-transition"
                                    reverse-transition="fade-transition"
                                    key="v-packages-drafts-list">
                                    <v-packages-drafts-list ref="v-packages-drafts-list"></v-packages-drafts-list>
                                </v-tab-item>
                                <v-tab-item
                                        transition="fade-transition"
                                        reverse-transition="fade-transition"
                                        key="v-packages-active-list">
                                    <v-packages-active-list ref="v-packages-active-list"></v-packages-active-list>
                                </v-tab-item>
                            </v-tabs-items>
                        </v-card>
                    </v-card-actions>
                </v-card>
            </v-card-actions>
        </v-card>
    </div>
</template>

<script>

import PackageStore from "@/modules/mpackages/database/PackageStore";
import VPackagesDraftsList from "@/modules/mpackages/views/p-packages-drafts-list";
import VPackagesActiveList from "@/modules/mpackages/views/p-packages-active-list";
import {PermissionsStoreUtils} from "@/modules/mpermissions/database/PermissionsStoreUtils";

export default {
    components: {VPackagesActiveList, VPackagesDraftsList},
    data: () => ({
        loading: true,
        message: "",
        tab: null,
        reloading:false,
    }),
    methods: {
        updateActiveTab(id){
            let name = id == 1 ? 'v-packages-drafts-list' : 'v-packages-active-list'
            let tab = this.$refs[name]
            if (tab != undefined){tab.reloadData()}
        },
        getMyUserUid(){
            return PermissionsStoreUtils.getMyUserUid();
        },
        ifCanViewDrafts(){
            return PermissionsStoreUtils.getPermission(this.getMyUserUid(), PermissionsStoreUtils.PACKAGE_TAB.subpermissions.PACKAGE_TAB_DRAFT_VIEW.id)
        },
        ifCanViewActive(){
           return PermissionsStoreUtils.getPermission(this.getMyUserUid(), PermissionsStoreUtils.PACKAGE_TAB.subpermissions.PACKAGE_TAB_ACTIVE_VIEW.id)
        },
    },
    beforeMount() {
        this.loading = true
        this.$store.registerModule("package-store", PackageStore);
        this.$store.dispatch("package-store/init").then(() => {
            console.log("Loaded successfully. package-store");
        }).catch(() => {
            this.message = "Load failed!";
        }).finally(() => {
            this.loading = false;
        });
    },
    destroyed() {
        this.$store.unregisterModule("package-store");
        console.log("destroy root view packages");
    }
}
</script>

<style scoped>
</style>